import { render, staticRenderFns } from "./WarningsList.vue?vue&type=template&id=3f045cc6&scoped=true&"
import script from "./WarningsList.vue?vue&type=script&lang=js&"
export * from "./WarningsList.vue?vue&type=script&lang=js&"
import style0 from "./WarningsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WarningsList.vue?vue&type=style&index=1&id=3f045cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f045cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VCard,VCardText,VCardTitle,VDataTable,VIcon,VMenu})
